// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import type { API } from './typings';

/** 获取当前的用户 POST /api/auth/current */
export async function PostAdminAuthCurrent(options?: { [key: string]: any }) {
  return request<API.Response<API.CurrentUser>>('/api/admin/auth/current', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Region': 'Null',
    },
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function PostAdminAuthOutLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/admin/auth/outLogin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Region': 'Null',
    },
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function PostAdminAuthLogin(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.Response<{ token: string }>>('/api/admin/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Region': 'Null',
    },
    data: body,
    ...(options || {}),
  });
}
